import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=6187ccca&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=6187ccca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6187ccca",
  null
  
)

export default component.exports